import { hubApplication } from './hub';
import { lensApplication } from './lens';
import { therapiesSitesApplication } from './therapies-sites';
import { therapiesSponsorsApplication } from './therapies-sponsors';

export const APPLICATIONS = [hubApplication, lensApplication, therapiesSitesApplication, therapiesSponsorsApplication];
